<template>
  <div>
    <b-row class="mt-4">
      <b-col>
        <b-alert show variant="info">
          <p>
            <strong>{{ $t('info.choice') }}</strong>
          </p>
          <ul>
            <li v-for="item in selectList" :key="item.Id">
              {{ item.NOMDIV }}
            </li>
          </ul>
        </b-alert>
      </b-col>
    </b-row>

    <div class="mt-2" v-if="tableData.length > 0">
      <b-row class="pt-2">
        <b-col sm="6" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="6" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-2">
        <b-col sm="6" class="mt-2">
          <b-form-input
            v-model="search"
            :placeholder="$t('action.search')"
          ></b-form-input>
          <b-button variant="link" @click="resetTable()">{{
            $t("action.reset")
          }}</b-button>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table
            id="MultiSelectTable"
            stacked="lg"
            bordered
            :fields="fields"
            :items="items"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(details)="row">
              <b-button
                :variant="row.item.buttonStyle"
                class="ml-2"
                size="sm"
                @click="onSelected(row.item)"
                >{{ row.item.buttonStyle === 'outline-success' ? $t("action.choose") : $t("action.remove") }}</b-button
              >
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="MultiSelectTable"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tableDataFromProp", "fields", "tableName"],
  data() {
    return {
      tableData: this.getTableData(),
      count: null,
      sortBy: "NOMDIV",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      selectList: this.getSelectList(),
      addToDl: 'no'
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    items: function () {
      let find = [];
      let mydatalist = this.tableData;
      let sl = this.search.toLowerCase();
      let s = sl.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); //Remove accent

      if (mydatalist.length > 0) {
        find = mydatalist.filter((o) => {
          let nd = o.NOMDIV ? o.NOMDIV : "";
          let NOMDIV = nd.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          let NOCIE = o.NOCIE ? o.NOCIE.toString() : "";
          let NODIV = o.NODIV ? o.NODIV.toString() : "";

          let Creation = o.Creation ? o.Creation : "";

          return (
            NOMDIV.toLowerCase().includes(s) ||
            NOCIE.toLowerCase().includes(s) ||
            NODIV.toLowerCase().includes(s) ||
            Creation.toLowerCase().includes(s)
          );
        });
      }

      return find;
    },
    displayList: function () {
      let map = this.selectList.map((s) => {
        return s.displayName;
      });

      return map;
    },
  },
  methods: {
    getSelectList: function () {
      return this.$store.getters.getBuildingListForUser;
    },
    getTableData: function () {
      let listToCheck = this.$store.getters.getBuildingListForUser; //liste des buildings pour modification
      let tableDataFromProp = this.tableDataFromProp;
     
      let tableData = tableDataFromProp.map(t => {
        if (listToCheck.some(a => a.Id === t.Id)) {
          t.buttonStyle = "success";
        }
        else {
          t.buttonStyle = "outline-success";
        }
        return t;
      });

      return tableData;
    },
    resetTable: function () {
      this.search = "";
    },
    onSelected: function (item) {
      let selectarr = this.selectList;
      let dlArr = this.tableData;
      let found = selectarr.find((s) => s.Id === item.Id);
      if (found) { 
        this.selectList = selectarr.filter((s) => s.Id !== found.Id);
        this.tableData = dlArr.map(d => {
          if (d.Id === found.Id) {
            d.buttonStyle = 'outline-success';
          }
          return d;
        });
      } else {
        this.selectList.push(item);
        this.tableData = dlArr.map(d => {
          if (d.Id === item.Id) {
            d.buttonStyle = 'success';
          }
          return d;
        });
      }
      this.$store.commit("addBuildingListForUser", this.selectList);
    },
  },
};
</script>
